<template>
  <div class="private-page">
    <el-card shadow="never">
      <div class="card-header">
        <div>
          <h3>💬 私域管理（微信引流）</h3>
          <p class="sub">截流线索 → 引导加微信 → 标记已添加，形成私域沉淀</p>
        </div>
        <div class="header-actions">
          <el-select v-model="filterStatus" placeholder="状态筛选" clearable style="width:140px" @change="load">
            <el-option label="全部" value="" />
            <el-option label="已发引导" value="invited" />
            <el-option label="已添加微信" value="added" />
          </el-select>
          <el-button type="primary" plain @click="openConfig">⚙️ 微信号配置</el-button>
        </div>
      </div>

      <el-table :data="items" v-loading="loading" stripe>
        <el-table-column label="客户" min-width="160">
          <template #default="{row}">
            <div class="user-cell">
              <el-avatar :size="32" :src="row.avatar || undefined">{{ (row.nickname || row.username || '?')[0] }}</el-avatar>
              <div>
                <div class="nick">{{ row.nickname || row.username || '未知名' }}</div>
                <div class="sub2">{{ row.username || '' }} · {{ row.platform }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="意向分" width="80">
          <template #default="{row}">
            <el-tag :type="row.score >= 3 ? 'danger' : row.score >= 1 ? 'warning' : 'info'" size="small">{{ row.score }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="来源关键词" prop="source_keyword" min-width="120" show-overflow-tooltip />
        <el-table-column label="微信状态" width="110">
          <template #default="{row}">
            <el-tag v-if="row.wechat_status === 'added'" type="success" size="small">✅ 已添加</el-tag>
            <el-tag v-else-if="row.wechat_status === 'invited'" type="warning" size="small">📨 已发引导</el-tag>
            <el-tag v-else type="info" size="small">未引导</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="微信号" prop="wechat" width="120">
          <template #default="{row}">{{ row.wechat || '—' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template #default="{row}">
            <el-button size="small" type="primary" plain :disabled="row.wechat_status === 'added'" @click="sendInvite(row)">📨 发引导</el-button>
            <el-button size="small" type="success" plain :disabled="row.wechat_status === 'added'" @click="openMark(row)">➕ 已添加</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-empty v-if="!loading && items.length === 0" description="暂无高意向线索，先采集/打标后再来转化" />
    </el-card>

    <!-- 微信号配置 -->
    <el-dialog v-model="configVisible" title="⚙️ 微信号配置" width="520px">
      <el-form label-width="90px">
        <el-form-item label="我的微信号">
          <el-input v-model="cfg.wechat" placeholder="如 laoke2026，引导话术将带上这个号" />
        </el-form-item>
        <el-form-item label="引导话术">
          <el-input v-model="cfg.template" type="textarea" :rows="5" placeholder="可用 {keyword} {industry} {wechat} 占位符" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="configVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveConfig">保存</el-button>
      </template>
    </el-dialog>

    <!-- 标记已添加 -->
    <el-dialog v-model="markVisible" :title="'➕ 标记已添加微信 — ' + (markRow?.nickname || '')" width="420px">
      <el-form label-width="90px">
        <el-form-item label="客户微信">
          <el-input v-model="markForm.wechat" placeholder="客户主动留的微信号（可留空）" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="markForm.note" placeholder="如：已加微信，待报价" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="markVisible = false">取消</el-button>
        <el-button type="success" :loading="saving" @click="doMark">确认已添加</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'PrivatePage',
  data() {
    return {
      loading: false,
      saving: false,
      items: [],
      filterStatus: '',
      configVisible: false,
      markVisible: false,
      markRow: null,
      markForm: { wechat: '', note: '' },
      cfg: { wechat: '', template: '' }
    }
  },
  created() {
    this.load()
    this.loadConfig()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const params = { limit: 200 }
        if (this.filterStatus) params.wechat_status = this.filterStatus
        const res = await api.get('/private', { params })
        this.items = res.items || []
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.loading = false
      }
    },
    async loadConfig() {
      try {
        const res = await api.get('/private/wechat-config')
        this.cfg = res
      } catch (e) { /* ignore */ }
    },
    openConfig() {
      this.loadConfig()
      this.configVisible = true
    },
    async saveConfig() {
      this.saving = true
      try {
        await api.put('/private/wechat-config', this.cfg)
        this.$message.success('配置已保存 ✅')
        this.configVisible = false
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.saving = false
      }
    },
    async sendInvite(row) {
      if (!this.cfg.wechat) {
        this.$message.warning('请先配置微信号（点右上角「⚙️ 微信号配置」）')
        this.openConfig()
        return
      }
      try {
        const res = await api.post(`/private/${row.id}/invite`, { wechat: this.cfg.wechat })
        this.$alert('已生成引导话术（已写入线索备注留痕）：\n\n' + (res.invite_text || ''), '📨 微信引导', { confirmButtonText: '知道了' })
        this.load()
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    openMark(row) {
      this.markRow = row
      this.markForm = { wechat: row.wechat || '', note: '' }
      this.markVisible = true
    },
    async doMark() {
      this.saving = true
      try {
        await api.post(`/private/${this.markRow.id}/mark-added`, this.markForm)
        this.$message.success('已标记添加微信 ✅')
        this.markVisible = false
        this.load()
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.private-page { padding: 4px; }
.card-header { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; margin-bottom: 12px; }
.sub { color: #999; font-size: 12px; margin-top: 4px; }
.user-cell { display: flex; align-items: center; gap: 8px; }
.nick { font-weight: 600; }
.sub2 { color: #999; font-size: 12px; }
</style>
